module.exports = __webpack_public_path__ + "img/health2_7-9-2021.941fb05e.jpg";